import { useEffect, useState } from 'react';
import { useSwitchChain, useChainId } from 'wagmi';
import { activeChain } from '@/config/wagmi';

export function useNetworkSwitch() {
  const currentChainId = useChainId();
  const { switchChainAsync, isPending } = useSwitchChain();
  const [error, setError] = useState<string | null>(null);

  const isCorrectNetwork = currentChainId === activeChain.id;
  const requiredNetwork = activeChain.name;
  const requiredChainId = activeChain.id;

  const switchToCorrectNetwork = async () => {
    if (isCorrectNetwork) return true;

    setError(null);
    try {
      await switchChainAsync({ chainId: activeChain.id });
      return true;
    } catch (err) {
      const message =
        err instanceof Error ? err.message : 'Failed to switch network';
      setError(message);
      return false;
    }
  };

  // Auto-clear error after 5 seconds
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(null), 5000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [error]);

  return {
    currentChainId,
    isCorrectNetwork,
    requiredNetwork,
    requiredChainId,
    switchToCorrectNetwork,
    isSwitching: isPending,
    error,
    clearError: () => setError(null),
  };
}
